import { render, staticRenderFns } from "./ImagePopup.vue?vue&type=template&id=05125804&scoped=true&"
import script from "./ImagePopup.vue?vue&type=script&lang=js&"
export * from "./ImagePopup.vue?vue&type=script&lang=js&"
import style0 from "./ImagePopup.vue?vue&type=style&index=0&id=05125804&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05125804",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VIcon,VImg,VProgressCircular,VRow})
